var React = require('react');

function Filters (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.7","d":"M2 2l6 6.832v4.724L12.03 15V8.832L17 2z"}));
}

Filters.defaultProps = {"width":"19","height":"17","viewBox":"0 0 19 17"};

module.exports = Filters;

Filters.default = Filters;
